// extracted by mini-css-extract-plugin
module.exports = {"card":"Tile_card__1iNaC","cardWrap":"Tile_cardWrap__25iAc","titleLink":"Tile_titleLink__1JcMk"};